import PullToRefresh from "react-simple-pull-to-refresh";
import { Loader2Icon, ChevronDown } from "lucide-react";

export default function PulledDownWrapper({ onRefresh, children, className = "" }) {

const LoadingComp = () => {
    return (<><Loader2Icon className="animate-spin" /></>)
}
const PullContent = () => {
    return (<><ChevronDown/></>)
}
return (
<PullToRefresh onRefresh={onRefresh} resistance={2.5} pullDownThreshold={70}
    refreshingContent={
        <div className="py-6 flex justify-center">
            <LoadingComp />
        </div>
    }
    pullingContent={
        <div className="py-6 flex justify-center">
            <PullContent />
        </div>
    }>
    <div className={`w-full ps-4 pe-4 pb-[100px] ${className}`} style={{overscrollBehaviorY: "contain"}}>
        {children}
    </div>
</PullToRefresh>
);
}